import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'timezoneDate',
})
export class TimezoneDatePipe implements PipeTransform {
  /**
   * Format a date using a specific timezone
   * @param value - The date to format
   * @param format - Moment.js format string (default: 'h:mm A')
   * @param timezone - Timezone string (e.g., 'America/New_York')
   * @returns Formatted date string
   */
  transform(value: Date | string | moment.Moment, format: string = 'h:mm A', timezone?: string): string {
    if (!value) return '';

    try {
      if (timezone) {
        // Format the date in the specified timezone
        return moment(value).tz(timezone).format(format);
      } else {
        // Fallback to local timezone formatting
        return moment(value).format(format);
      }
    } catch (error) {
      console.warn('TimezoneDatePipe: Error formatting date', error);
      // Fallback to standard Angular date behavior
      return moment(value).format(format);
    }
  }
}
